import Particle from "./Particle";
import AbstractParticles from "./AbstractParticles";

class TripleParticles extends AbstractParticles {
  // ---------------------------------------------------------------------------
  // --	TripleParticles
  // ---------------------------------------------------------------------------

  constructor() {
    super(".js-bg-triple-marker");

    //変数調整
    this.baseRotSpeed = 0.2;
    this.srollRotSpeed = 20;

    for (let i = 0; i < 3; i++) {
      const particle = new Particle();
      particle.setScaleByPX(140);
      particle.alpha = 0.4;
      particle.randomMove(300, 600);
      this.container.addChild(particle);
    }
  }

  // ---------------------------------------------------------------------------
}

export default TripleParticles;
